// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

/**
 * Which of a target bank's lifts a bank overlay draws on (see
 * `Bank.overlay_bank_id`).
 *
 * A bank overlay re-publishes the source bank's control state on the target
 * bank, so a module bank that is not visible -- an interlock's discrete
 * inputs, say -- shows its effect on the bank operators watch. Floor positions
 * carry across unchanged.
 *
 * - `ALL_LIFTS` draws each source message on every lift of the target bank:
 *   the source reports per floor, and the floor is the same for every car (a
 *   secured-floor input bank with one car standing for the whole floor).
 * - `SAME_CAR_NUMBER` draws source lift N on target lift N, where N is the
 *   lift's rank after sorting each bank's lifts by `(position, id)`. A lift
 *   with no counterpart in the other bank draws nothing.
 *
 * `ALL_LIFTS` is 0 and the declared default, so a bank written before this
 * field existed, or one that sets only `overlay_bank_id`, decodes as drawing
 * on every lift. Append-only, like every enum here. Stored as `smallint` in
 * `LiftCloud`, for the reason given on `KeyDirection`.
 */
export enum OverlayLifts {
  ALL_LIFTS = 0,
  SAME_CAR_NUMBER = 1,
}
